module.exports = __webpack_public_path__ + "static/media/city_no_branding.1a7b6b09.glb";